import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { getUserIsLoggedIn } from '../../../Utils/helper';
import { sendSmsMobile } from '../../../datafetchers/LoginPopup/sendSmsMobile';
import Loader from '../../Loader';
import { apiEvent } from '../utils';
import EnterOtp from './EnterOtp';
import EnterPhone from './EnterPhone/EnterPhone';
import LoginHeading from './LoginHeading';
import RedirectScreen from './RedirectScreen';
import { fromSkip } from './common';
import { discardGuestPopup } from './instrumentation';
import { setWebUserIdReact } from '../../../Utils/commonUtils';
import GlobalStyle from '../../../styles/globalStylesV2';

function NewLoginScreen(props) {
  const { onLoginSuccess } = props;
  const router = useRouter();
  const showRedirecting = getUserIsLoggedIn() || Cookies.get(fromSkip);
  const { fromAddress, fromOrder, needHelp } = router.query;
  const [verifyOtpScreen, setVerifyOtpScreen] = useState(false);
  const [hashedValue, setHashedValue] = useState();
  const [showGuestPopup, setShowGuestPopup] = useState(false);
  // const [showSkipButton, setShowSkipButton] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [clickEffect, setClickEffect] = useState('');
  const [otpTries, setOtpTries] = useState(0);
  const apiCallTime = useRef();

  const mobileNumber = useRef();
  const sendOtp = async () => {
    const data = getMobileNumber();
    const resp = await window.__KP_LOGIN_SDK_INSTANCE__.kpSendOTP(data.mobile);
    setOtpTries(0);

    if (resp?.status == 200 && resp?.body?.success) {
      setVerifyOtpScreen(true);
      apiCallTime.current = new Date();
    }
    // const response = await sendSmsMobile(data);
    // apiEvent("api/sendSMS");
    // setOtpTries(0);
    // if (response?.success) {
    //     setHashedValue(response.data);
    //     setVerifyOtpScreen(true);
    //     apiCallTime.current = new Date();
    // }
  };

  const hideGuestPopup = () => {
    localStorage.setItem('guestPopupRemoved', true);
    setShowGuestPopup(false);
    discardGuestPopup();
  };

  const getMobileNumber = () => {
    return { mobile: mobileNumber.current };
  };
  return (
    <>
      <GlobalStyle />
      {showRedirecting ? (
        <RedirectScreen />
      ) : (
        <>
          {!showRedirecting ? <LoginHeading /> : null}
          {/* <span onClick={() => router.back()} className="cross_icon">
                        <img src={images?.blackCross} alt="BlackCross" />
                    </span> */}
          {verifyOtpScreen ? (
            <EnterOtp
              hashedValue={hashedValue}
              mobileNumber={mobileNumber}
              apiCallTime={apiCallTime}
              sendOtp={sendOtp}
              setVerifyOtpScreen={setVerifyOtpScreen}
              fromAddress={fromAddress}
              fromOrder={fromOrder}
              setOtpTries={setOtpTries}
              otpTries={otpTries}
              needHelp={needHelp}
              onLoginSuccess={onLoginSuccess}
            />
          ) : (
            <EnterPhone
              sendOtp={sendOtp}
              mobileNumber={mobileNumber}
              fromAddress={fromAddress}
            />
          )}

          {showLoader && <Loader />}
        </>
      )}
    </>
  );
}

export default NewLoginScreen;
